import {
  FilterSettingsProvider,
  getCustomerId,
  getGeneralSettingsFromAdmin,
  RecommendationWidget,
  ThemeProvider,
} from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

import type { Block, Dict } from '../types';

export type RecommendationBlock = Block<{
  node: Element;
}>;

export const createRecommendationBlock = (
  config: RecommendationBlock['config']
): RecommendationBlock => {
  return {
    config,
    render() {
      const { node } = config;
      const { id } = node;

      const generalSettings = getGeneralSettingsFromAdmin();
      let page = generalSettings.page;
      if (page === 'index') {
        page = 'home';
      }

      const widgetId = id.split('-').at(-1);
      if (!widgetId) return;

      const { defaultSettings, widgets } = window.boostSDRecommendationConfig;
      let widget: Dict | undefined;

      Object.keys(widgets?.[generalSettings.page] || {}).some((key) => {
        const id = key.split('-').at(-1);
        if (id === widgetId) {
          widget = widgets[generalSettings.page][key];

          // save wid to params
          if (widget) widget.params.wid = key;
          return true;
        }

        return false;
      });

      if (!widget) return;

      const { params, widgetDesignSettings, widgetName } = widget;
      const customerId = getCustomerId();
      if (customerId) {
        params.customerId = String(customerId);
      }

      // handle recommendationType recently-purchased
      const { recommendationType } = params;
      if (recommendationType === 'recently-purchased' && !customerId) {
        return;
      }
      const root = createRoot(node);

      root.render(
        <ThemeProvider>
          <FilterSettingsProvider>
            <RecommendationWidget
              widgetName={widgetName}
              params={params}
              designSettings={{
                ...widgetDesignSettings,
                ...(widgetDesignSettings.templateType === 'default' ? defaultSettings : {}),
              }}
              page={page}
              product={window.boostSDData.product}
            />
          </FilterSettingsProvider>
        </ThemeProvider>
      );
    },
  };
};

const defaultConfig = {
  widgetPlacementIdPrefix: 'boost-sd-widget-',
};

export const createAvailableRecommendationBlocks = (
  config: {
    widgetPlacementIdPrefix?: string;
  } = defaultConfig
) => {
  const blocks: RecommendationBlock[] = [];
  return {
    config: {
      ...defaultConfig,
      ...config,
    },
    blocks,
    render() {
      const { widgetPlacementIdPrefix } = {
        ...defaultConfig,
        ...config,
      };

      const widgetPlacements = document.querySelectorAll(`[id^='${widgetPlacementIdPrefix}']`);

      if (widgetPlacements?.length) {
        widgetPlacements.forEach((node) => {
          const block = createRecommendationBlock({ node });

          blocks.push(block);
          block.render();
        });
      }
    },
  };
};
